var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLivroAberto01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_15_",
    d: "M18,34.6c-0.4,0-0.9-0.2-1.2-0.5c0,0,0,0,0,0c0,0,0,0,0,0l-2-2c-0.7-0.7-1.5-1-2.5-1h-10 c-1,0-1.7-0.8-1.7-1.7V3.2c0-1,0.8-1.7,1.7-1.7h12.2c1.3,0,2.5,0.5,3.5,1.4c1-0.9,2.2-1.4,3.5-1.4h12.2c1,0,1.7,0.8,1.7,1.7v26.1 c0,1-0.8,1.7-1.7,1.7h-10c-0.9,0-1.8,0.4-2.5,1l-2,2c0,0,0,0,0,0c0,0,0,0,0,0C18.9,34.4,18.4,34.6,18,34.6z M21.5,4.9 c-1,0-1.7,0.8-1.7,1.7v22.1c1.2-0.8,2.5-1.2,3.9-1.2h8.3V4.9H21.5z M4.1,4.9v22.7h8.3c1.4,0,2.8,0.4,3.9,1.2V6.7 c0-1-0.8-1.7-1.7-1.7H4.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLivroAberto01);
export default __webpack_public_path__ + "static/media/ico-livro-aberto-01.e13ef92578d778c9045b8f5c2547606b.svg";
export { ForwardRef as ReactComponent };